// extracted by mini-css-extract-plugin
module.exports = {"card":"card--3k0FU"};